/**
 * Nasconde il badge reCAPTCHA per evitare errori di accessibilità (WAVE).
 * Viene eseguito automaticamente all'import — non richiede chiamata esplicita.
 */
(function initRecaptchaBadgeHider(): void {
    function hideRecaptchaBadge(): void {
        const badge = document.querySelector<HTMLElement>('.grecaptcha-badge');
        if (!badge) return;

        badge.setAttribute('aria-hidden', 'true');
        badge.style.setProperty('display', 'none', 'important');

        badge.querySelectorAll<HTMLTextAreaElement>('textarea').forEach((el) => {
            el.setAttribute('aria-hidden', 'true');
            el.setAttribute('aria-label', 'reCAPTCHA response token');
            el.setAttribute('role', 'presentation');
            el.setAttribute('tabindex', '-1');
            el.style.setProperty('display', 'none', 'important');
        });

        badge.querySelectorAll<HTMLIFrameElement>('iframe').forEach((el) => {
            el.setAttribute('aria-hidden', 'true');
        });
    }

    // Esegui subito se grecaptcha è già disponibile
    if (typeof grecaptcha !== 'undefined') {
        grecaptcha.ready(() => {
            hideRecaptchaBadge();
            setTimeout(hideRecaptchaBadge, 100);
            setTimeout(hideRecaptchaBadge, 500);
        });
    }

    // Fallback: controlla ogni 500ms per un massimo di 10 secondi
    let checkCount = 0;
    const checkInterval = setInterval(() => {
        hideRecaptchaBadge();
        if (++checkCount >= 20) clearInterval(checkInterval);
    }, 500);

    // MutationObserver: riapplica se Google modifica il DOM dopo il caricamento
    if (typeof MutationObserver !== 'undefined') {
        setTimeout(() => {
            new MutationObserver(hideRecaptchaBadge).observe(document.body, {
                childList: true,
                subtree:   true,
                attributes: false,
            });
        }, 1000);
    }
})();
